module.exports = __webpack_public_path__ + "assets/assets/images/instructions/opinion.087589da.svg";


//////////////////
// WEBPACK FOOTER
// ./client/assets/images/instructions/opinion.svg
// module id = 240
// module chunks = 0